/* ONZE: Zustand und Countdown für Auktions-Badges auf Produktkarten.
   Liest Start- und Endzeit aus data-start / data-end (vom Metafeld der App). */
(function () {
  if (window.onzeAuctionLoaded) return;
  window.onzeAuctionLoaded = true;

  var DEFAULTS = {
    upcoming: 'Auction starts in',
    live: 'Ongoing auction · ends in',
    ended: 'Auction ended'
  };

  function text(el, name) {
    var t = el.getAttribute('data-text-' + name);
    return t && t.trim() ? t.trim() : DEFAULTS[name];
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatLeft(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + pad(m) + 'm';
    return m + 'm ' + pad(sec) + 's';
  }

  /* Zwei Teile (Status und Zeit) mit Leerzeichen dazwischen: Dort darf der Badge umbrechen. */
  function render(el, label, time) {
    var l = el.querySelector('.onze-auction-badge__label');
    var t = el.querySelector('.onze-auction-badge__time');
    if (!l || !t) {
      el.textContent = '';
      l = document.createElement('span');
      l.className = 'onze-auction-badge__label';
      t = document.createElement('span');
      t.className = 'onze-auction-badge__time';
      el.appendChild(l);
      el.appendChild(document.createTextNode(' '));
      el.appendChild(t);
    }
    // Steht im Text ein «·», dort immer umbrechen (Punkt nicht anzeigen):
    // oben der Teil davor, unten der Teil danach zusammen mit der Zeit
    var head = label;
    var tail = '';
    var dot = label.indexOf('·');
    var split = !!time && dot !== -1;
    if (split) {
      head = label.slice(0, dot).trim();
      tail = label.slice(dot + 1).trim();
    }
    if (split !== el.hasAttribute('data-split')) {
      if (split) el.setAttribute('data-split', '');
      else el.removeAttribute('data-split');
      el.removeAttribute('data-fitted');
    }
    var timeText = (tail + ' ' + time).trim();
    var changed = false;
    if (l.textContent !== head) { l.textContent = head; changed = true; }
    if (t.textContent !== timeText) { t.textContent = timeText; changed = true; }
    if (t.hidden !== !time) { t.hidden = !time; changed = true; }
    if (changed || !el.hasAttribute('data-fitted')) {
      el.setAttribute('data-fitted', '');
      fit(el);
    }
  }

  /* Bricht die Zeit in die zweite Zeile um, Status und Zeit untereinander stellen,
     damit der Badge nicht unnötig breit bleibt. */
  function fit(el) {
    var l = el.querySelector('.onze-auction-badge__label');
    var t = el.querySelector('.onze-auction-badge__time');
    if (!l || !t || el.offsetParent === null) return;
    if (t.hidden) {
      el.classList.remove('is-stacked');
      return;
    }
    if (el.hasAttribute('data-split')) {
      el.classList.add('is-stacked');
      return;
    }
    var stacked = el.classList.contains('is-stacked');
    if (stacked) el.classList.remove('is-stacked');
    var wraps = t.offsetTop > l.offsetTop + 2;
    el.classList.toggle('is-stacked', wraps);
  }

  function fitAll() {
    var els = document.querySelectorAll('[data-onze-auction="badge"]');
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }

  function stateOf(el, now) {
    var start = Date.parse(el.getAttribute('data-start'));
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(start) || isNaN(end)) return null;
    if (now < start) return { name: 'upcoming', left: start - now };
    if (now < end) return { name: 'live', left: end - now };
    return { name: 'ended', left: 0 };
  }

  function tick() {
    var now = Date.now();
    var els = document.querySelectorAll('[data-onze-auction]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var st = stateOf(el, now);
      if (!st) continue;
      if (el.getAttribute('data-onze-auction') === 'badge') {
        render(el, text(el, st.name), st.name === 'ended' ? '' : formatLeft(st.left));
        el.setAttribute('data-state', st.name);
        // Für die Auktions-Tabs der Kollektion: beendete Auktion in «Past auctions» verschieben
        if (st.name === 'ended' && !el.hasAttribute('data-ended-sent')) {
          el.setAttribute('data-ended-sent', '');
          el.dispatchEvent(new CustomEvent('onze:auction-ended', { bubbles: true }));
        }
      } else {
        el.hidden = st.name !== 'upcoming';
      }
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitAll, 100);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
